import { render } from "./peoplePage.vue?vue&type=template&id=dad38a08&scoped=true"
import script from "./peoplePage.vue?vue&type=script&lang=js"
export * from "./peoplePage.vue?vue&type=script&lang=js"

import "./peoplePage.vue?vue&type=style&index=0&id=dad38a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad38a08"]])

export default __exports__